import { Box, Chip, IconButton, InputAdornment, MenuItem, Select, TextField, Typography, Button, FormControl, InputLabel, Autocomplete } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import FolderIcon from "@mui/icons-material/Folder";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid2";
import "./styles.scss"; // Import your styles
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { selectMainState, useDispatch, useSelector } from "src/stateManagement/redux";
import { deletedFile, uploadFileToServer } from "src/stateManagement/redux/slices/location/asyncReducers";
import Swal from 'sweetalert2';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VrpanoIcon from '@mui/icons-material/Vrpano';
import { FilePreviewModal } from "./fileDetaile";
import ClearIcon from '@mui/icons-material/Clear';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { IUpdateDiagnosticForActivity } from "src/shared/util/updateDataServer";
import { tableStyles } from "src/shared/util/tableStyles";

export interface ListOfActivities {
    id: string;
    label: string;
}

export const FileAttachment = (
    { originActivityId,
        activeDiagnostic,
        addRemoveAttachment,
    }: {
        originActivityId?: string,
        addRemoveAttachment?: (row: any) => void,
        activeDiagnostic?: IUpdateDiagnosticForActivity
    }
) => {

    const { configModules } = useSelector(selectMainState);

    const { locationId, fieldActivities, locationName, attachments } = useSelector(
        (state) => state.location
    );

    const dispatch = useDispatch();

    useEffect(() => {

        const ListOfActivities = fieldActivities.map((activity: any) => {
            const variables = activity?.variables?.find((variable: any) => variable.id === "6d7ad753-bb56-479a-ac5c-d26039113564");
            const executedDate = activity?.executedDate;
            const typeOfActivity = activity?.typeOfActivity;
            const executedBy = activity?.executedBy;

            return {
                id: activity.fieldActivityId,
                label: `${executedDate} - ${typeOfActivity} - ${executedBy}`
            }
        })

        if (Array.isArray(ListOfActivities)) {
            setListOfFieldActivities(ListOfActivities)
        }

    }, [fieldActivities])

    const [filters, setFilters] = useState({
        type: "",
        uploadedBy: "",
        tags: "",
        extension: "",
        description: "",
        search: "",
    });

    const [showUpload, setShowUpload] = useState(false);

    const initialFormState: any = {
        name: "",
        tags: [] as string[],
        type: "",
        file: null as File | null,
        description: "",
        originFieldActivityId: originActivityId || "",
        locationName: locationName,
        originFieldActivityDescription: "",
        attachedRelatedDate: null,
    }

    const [form, setForm] = useState({
        name: "",
        tags: [] as string[],
        type: "",
        file: null as File | null,
        description: "",
        originFieldActivityId: "",
        locationName: locationName,
        originFieldActivityDescription: "",
        attachedRelatedDate: new Date(),
    });

    useEffect(() => {
        if (originActivityId) {

            const fieldActivity = fieldActivities.find((activity: any) => activity.fieldActivityId === originActivityId);

            setForm(f => ({
                ...f,
                originFieldActivityId: originActivityId,
                attachedRelatedDate: fieldActivity?.executedDate ? new Date(fieldActivity.executedDate) : new Date()
            }));
        }
    }, [originActivityId, showUpload])


    const fileInputRef = useRef<HTMLInputElement>(null);

    const [types, setTypes] = useState<string[]>([]);
    const [tags, setTags] = useState<{ name: string; description: string }[]>([]);

    const [columns, setColumns] = useState<any[]>([])

    const [listOfFieldActivities, setListOfFieldActivities] = useState<ListOfActivities[]>([])

    // const types = ["Excel", "PowerPoint", "Drawio"];
    // const users = ["Jonathan", "Avila"];
    // const tags = ["Reportes", "OFM", "Muestras", "Consolidados"];
    // const extensions = ["xlsx", "pptx", "drawio"];

    const [extensions, setExtensions] = useState<string[]>([]);

    const [users, setUsers] = useState<string[]>([]);

    const [filteredRows, setFilteredRows] = useState<any>([]);

    const [showFileId, setShowFileId] = useState<string | null>(null);

    useEffect(() => {
        const filesTypes = configModules?.filesType
        const tags = configModules?.filesTags
        setTypes(filesTypes || [])
        setTags(tags || [])

    }, [configModules])

    useEffect(() => {

        let newFilteredRows = attachments.filter(row =>
            (filters.type ? row.type === filters.type : true) &&
            (filters.uploadedBy ? row.userCreated.fullName === filters.uploadedBy : true) &&
            (filters.tags ? row.tags.some((tag: any) => tag === filters.tags) : true) &&
            (filters.extension ? row.extension.includes(filters.extension) : true) &&
            (filters.search ? row.fileName.toLowerCase().includes(filters.search.toLowerCase()) || row.description.toLowerCase().includes(filters.search.toLowerCase()) : true)
        );

        const extensions = Array.from(new Set(attachments.map(row => row.extension)));

        setExtensions(extensions);

        const users = Array.from(new Set(attachments.map(row => row.userCreated.fullName)));

        setUsers(users);

        setFilteredRows(newFilteredRows);

        setColumns([
            {
                field: "executedAt",
                headerName: "Fecha",
                align: "center",
                headerAlign: "center",
                flex: 0.3,
                renderCell: (params: any) => {
                    // Format as YYYY-MM-DD
                    // return params.value
                    //     ? moment(params.value).format("DD-MM-YYYY")
                    //     : "";

                    return (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: "1.4",
                                    py: "5px",
                                    px: "2px",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    display: "-webkit-box",
                                }}
                            >
                                {params.value ? moment(params.value).format("DD-MM-YYYY"): ""}
                            </Typography>
                        </Box>
                    )
                },
            },
            {
                field: "fileName",
                headerName: "Nombre",
                flex: 0.4,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => {
                    return (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: "1.4",
                                    py: "5px",
                                    px: "2px",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    display: "-webkit-box",
                                }}
                            >
                                {params.row.fileName}
                            </Typography>
                        </Box>
                    );
                },
            },
            {
                field: "type",
                headerName: "Tipo",
                flex: 0.4,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => {
                    return (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: "1.4",
                                    py: "5px",
                                    px: "2px",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    display: "-webkit-box",
                                }}
                            >
                                {params.row.type}
                            </Typography>
                        </Box>
                    );
                },
            },
            {
                field: "description",
                headerName: "Descripción",
                flex: 0.8,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => {
                    return (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: "1.4",
                                    py: "5px",
                                    px: "2px",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    display: "-webkit-box",
                                }}
                            >
                                {params.row.description}
                            </Typography>
                        </Box>
                    );
                },
            },
            {
                field: "tags",
                headerName: "Etiquetas",
                flex: 1,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => (
                    <Grid
                        sx={{
                            display: "flex",
                            justifyContent: 'center',
                            height: "100%",
                            margin: 1,
                            flexWrap: "wrap",
                            gap: 0.5,
                        }}
                    >
                        {params.row.tags.map((tag: string, index: number) => (
                            <Chip
                                key={index}
                                label={tag}
                                size="small"
                                sx={{ mb: 0.5 }}
                            />
                        ))}
                    </Grid>
                ),
            },
            {
                field: "extension",
                headerName: "Extensión",
                flex: 0.2,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => {
                    return (
                        <Box
                            sx={{
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: "1.4",
                                    py: "5px",
                                    px: "2px",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    display: "-webkit-box",
                                }}
                            >
                                {params.row.extension}
                            </Typography>
                        </Box>
                    );
                },
            },
            {
                field: "actions",
                headerName: "",
                width: 180,
                headerAlign: "center",
                align: "center",
                renderCell: (params: any) => {
                    return (
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "space-around",
                                height: "100%",
                            }}
                        >
                            {!originActivityId && (
                                <IconButton
                                    size="small"
                                    color="error"
                                    onClick={() =>
                                        handleDeleteRow(params.row.id)
                                    }
                                >
                                    <DeleteForeverIcon fontSize="medium" />
                                </IconButton>
                            )}
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() =>
                                    handleShowFileModal(params.row.id)
                                }
                            >
                                <VrpanoIcon fontSize="medium" />
                            </IconButton>
                            {addRemoveAttachment && (
                                <IconButton
                                    size="small"
                                    color="default"
                                    onClick={() =>
                                        handleOnSelectFileForDiagnostic(
                                            params.row
                                        )
                                    }
                                >
                                    {activeDiagnostic?.attachedFiles.find(
                                        (file) => file.id === params.row.id
                                    ) ? (
                                        <CheckBoxIcon
                                            fontSize="medium"
                                            sx={{ color: "blue" }}
                                        />
                                    ) : (
                                        <CheckBoxOutlineBlankIcon fontSize="medium" />
                                    )}
                                </IconButton>
                            )}
                        </Grid>
                    );
                },
            },
        ]);

    }, [attachments, filters, activeDiagnostic])


    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const fileName = e.dataTransfer.files[0] ? e.dataTransfer.files[0].name.replace(/\.[^/.]+$/, "") : "";
            setForm(f => ({ ...f, file: e.dataTransfer.files[0], name: fileName }));
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;

        const fileName = files && files[0] ? files[0].name.replace(/\.[^/.]+$/, "") : "";

        if (files && files[0]) {
            setForm(f => ({ ...f, file: files[0], name: fileName }));
        }
    };

    const handleUpload = () => {

        if (!form.name || !form.type || !form.file || !locationId) {
            Swal.fire({
                title: "Error",
                text: "Por favor, complete todos los campos obligatorios: Nombre, Tipo, Archivo y Ubicación.",
                icon: "warning",
                confirmButtonText: "Cerrar",
            });

            return
        }

        dispatch(uploadFileToServer({
            name: form.name,
            tags: form.tags,
            type: form.type,
            file: form.file!,
            description: form.description,
            locationId,
            originFieldActivityId: form.originFieldActivityId,
            sources: "attachment",
            locationName: form.locationName,
            originFieldActivityDescription: form.originFieldActivityDescription,
            attachedRelatedDate: form.attachedRelatedDate.toISOString()
        }, setShowUpload));

        setForm(initialFormState);
    }

    const handleDeleteRow = (rowId: string) => {

        Swal.fire({
            title: "¿Estás seguro?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.isConfirmed) {
                dispatch(deletedFile(rowId, locationId));
            }
        });
    }

    const handleShowFileModal = (fileId: string) => {
        setShowFileId(fileId);
    }

    const handleOnSelectFileForDiagnostic = (row: any) => {
        if (addRemoveAttachment) {
            addRemoveAttachment(row);
        }
    }

    return (
        <Box sx={{ width: "100%" }}>

            {showFileId && <FilePreviewModal id={showFileId} open={!!showFileId} onClose={() => setShowFileId(null)} />}

            {/* Barra de búsqueda y filtros */}
            <Box className="header_container">
                {!showUpload && (
                    <>
                        <Grid className="header_search_box_input">
                            <TextField
                                className="input_search"
                                placeholder="Buscar en archivos por nombre o descripción"
                                size="small"
                                variant="outlined"
                                value={filters.search}
                                onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
                                disabled={showUpload}
                                sx={{
                                    width: "100%",
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                            border: 0,
                                        },
                                        "&:hover fieldset": {
                                            border: 0,
                                        },
                                        "&.Mui-focused fieldset": {
                                            border: 0,
                                        },
                                    },
                                }}
                            />
                        </Grid>

                        <Grid className="header_buttons_sections">

                            <Grid className="filter_section">
                                <FormControl sx={{ display: "flex", flexDirection: "row", lignItems: "center" }}>
                                    <InputLabel>Tipo</InputLabel>
                                    <Select
                                        value={filters.type}
                                        onChange={e => setFilters(f => ({ ...f, type: e.target.value }))}
                                        displayEmpty
                                        label="Tipo"
                                        size="small"
                                        className="select_filter"
                                        disabled={showUpload}
                                    >
                                        {types?.map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}
                                    </Select>
                                    {filters.type && (
                                        <IconButton color="warning" onClick={() => setFilters(f => ({ ...f, type: "" }))}>
                                            <ClearIcon />
                                        </IconButton>
                                    )}
                                </FormControl>
                                <FormControl sx={{ display: "flex", flexDirection: "row", lignItems: "center" }}>
                                    <InputLabel>Subido por</InputLabel>
                                    <Select
                                        value={filters.uploadedBy}
                                        onChange={e => setFilters(f => ({ ...f, uploadedBy: e.target.value }))}
                                        displayEmpty
                                        label="Subido por"
                                        size="small"
                                        className="select_filter"
                                        disabled={showUpload}
                                    >
                                        {users.map(user => <MenuItem key={user} value={user}>{user}</MenuItem>)}
                                    </Select>
                                    {filters.uploadedBy && (
                                        <IconButton color="warning" onClick={() => setFilters(f => ({ ...f, uploadedBy: "" }))}>
                                            <ClearIcon />
                                        </IconButton>
                                    )}
                                </FormControl>
                                <FormControl sx={{ display: "flex", flexDirection: "row", lignItems: "center" }}>
                                    <InputLabel>Etiquetas</InputLabel>
                                    <Select
                                        value={filters.tags}
                                        onChange={e => setFilters(f => ({ ...f, tags: e.target.value }))}
                                        displayEmpty
                                        label="Etiquetas"
                                        size="small"
                                        className="select_filter"
                                        disabled={showUpload}
                                    >
                                        {tags.map(tag => <MenuItem key={tag.name} value={tag.name}>{tag.description}</MenuItem>)}
                                    </Select>
                                    {filters.tags && (
                                        <IconButton color="warning" onClick={() => setFilters(f => ({ ...f, tags: "" }))}>
                                            <ClearIcon />
                                        </IconButton>
                                    )}
                                </FormControl>
                                <FormControl sx={{ display: "flex", flexDirection: "row", lignItems: "center" }}>
                                    <InputLabel>Extensión</InputLabel>
                                    <Select
                                        value={filters.extension}
                                        onChange={e => setFilters(f => ({ ...f, extension: e.target.value }))}
                                        displayEmpty
                                        label="Extensión"
                                        size="small"
                                        className="select_filter"
                                        disabled={showUpload}
                                    >
                                        {extensions.map(ext => <MenuItem key={ext} value={ext}>{ext}</MenuItem>)}
                                    </Select>
                                    {filters.extension && (
                                        <IconButton color="warning" onClick={() => setFilters(f => ({ ...f, extension: "" }))}>
                                            <ClearIcon />
                                        </IconButton>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid className="button_add_file">
                                <IconButton
                                    color={showUpload ? "error" : "primary"}
                                    onClick={() => setShowUpload(s => !s)}
                                >
                                    {showUpload ? <CloseIcon /> : <AddCircleIcon />}
                                </IconButton>
                            </Grid>
                        </Grid>
                    </>
                )}

            </Box>

            {/* Sección de subida */}
            {showUpload ? (
                <Box className="upload_container">
                    <Grid className="title_section">
                        <Typography variant="h6">Subir Nuevo Archivo</Typography>
                        <IconButton
                            color={showUpload ? "error" : "primary"}
                            onClick={() => {
                                setForm(initialFormState);
                                setShowUpload(s => !s)
                            }}
                        >
                            {showUpload ? <CloseIcon /> : <AddCircleIcon />}
                        </IconButton>
                    </Grid>
                    <Grid className="body">
                        <Grid className="add_file_description_container">
                            <Grid className="left_section">
                                <TextField
                                    label="Nombre"
                                    fullWidth
                                    size="small"
                                    value={form.name}
                                    onChange={e => setForm(f => ({ ...f, name: e.target.value }))}
                                />
                                <FormControl>
                                    <InputLabel>Tipo</InputLabel>
                                    <Select
                                        label="Tipo"
                                        displayEmpty
                                        fullWidth
                                        size="small"
                                        value={form.type}
                                        onChange={e => setForm(f => ({ ...f, type: e.target.value }))}
                                    >
                                        {types.map(type => <MenuItem key={type} value={type}>{type}</MenuItem>)}
                                    </Select>
                                </FormControl>
                                <FormControl>
                                    {/* <InputLabel>Etiquetas</InputLabel> */}
                                    <Autocomplete
                                        multiple
                                        options={tags}
                                        getOptionLabel={(option) => option.description}
                                        value={tags.filter(tag => form.tags.includes(tag.name))}
                                        onChange={(event, newValue) => {
                                            setForm(f => ({
                                                ...f,
                                                tags: newValue.map(tag => tag.name)
                                            }));
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Etiquetas" size="small" fullWidth />
                                        )}
                                        renderOption={(props, option) => (
                                            <li {...props} key={option.name}>
                                                <Chip label={option.name} size="small" sx={{ mr: 1 }} />
                                                {option.description}
                                            </li>
                                        )}
                                    />
                                </FormControl>

                                {/* TODO AGREGAR FECHA */}
                                <DesktopDatePicker
                                    label={"Fecha de Adjunto"}
                                    sx={{
                                        width: "100%",

                                    }}
                                    name={"attachedRelatedDate"}
                                    value={form.attachedRelatedDate && moment(form.attachedRelatedDate)}
                                    onChange={(date) => {
                                        if (!date) return;

                                        setForm(f => ({ ...f, attachedRelatedDate: date ? date.toDate() : f.attachedRelatedDate }))
                                    }}
                                />
                            </Grid>
                            <Grid className="right_section">
                                <FormControl fullWidth>
                                    <Autocomplete
                                        disablePortal
                                        options={listOfFieldActivities}
                                        disabled={originActivityId ? true : false}
                                        value={listOfFieldActivities.find(x => x.id === form.originFieldActivityId) || null}
                                        renderInput={(params) => <TextField {...params} label="Actividad Asociada" name="originFieldActivityId" />}
                                        onChange={(event, newValue) => {
                                            setForm(f => ({
                                                ...f,
                                                originFieldActivityId: newValue?.id || "",
                                                originFieldActivityDescription: newValue?.label || ""
                                            }));
                                        }}
                                    />
                                </FormControl>
                                <TextField
                                    label="Descripción"
                                    fullWidth
                                    multiline
                                    rows={4}
                                    size="small"
                                    value={form.description}
                                    onChange={e => setForm(f => ({ ...f, description: e.target.value.length > 500 ? e.target.value.slice(0, 500) : e.target.value }))}
                                />
                                <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", }}>
                                    <Typography variant="caption" color={form.description.length > 500 ? "error" : "textSecondary"}>
                                        {form.description.length}/500
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        {/* Drop zone for files */}
                        <Grid>
                            <Box
                                sx={{
                                    border: "2px dashed #1976d2",
                                    borderRadius: 2,
                                    p: 3,
                                    textAlign: "center",
                                    background: "#e3f2fd",
                                    cursor: "pointer"
                                }}
                                onDrop={handleDrop}
                                onDragOver={e => e.preventDefault()}
                                onClick={() => fileInputRef.current?.click()}
                                onPaste={e => {
                                    const items = e.clipboardData?.items;
                                    if (items) {
                                        for (let i = 0; i < items.length; i++) {
                                            const item = items[i];
                                            if (item.kind === 'file' && item.type.startsWith('image/')) {
                                                const file = item.getAsFile();
                                                if (file) {
                                                    const fileName = file.name.replace(/\.[^/.]+$/, "");
                                                    setForm(f => ({ ...f, file, name: fileName }));
                                                }
                                            }
                                        }
                                    }
                                }}
                                tabIndex={0}
                            >
                                <input
                                    type="file"
                                    hidden
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                />
                                {form.file && form.file.type.startsWith('image/') ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, position: 'relative' }}>
                                        <IconButton
                                            size="small"
                                            sx={{ position: 'absolute', top: 0, right: 0, zIndex: 2, background: '#fff' }}
                                            onClick={e => {
                                                e.stopPropagation();
                                                setForm(f => ({ ...f, file: null }));
                                            }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                        <img
                                            src={URL.createObjectURL(form.file)}
                                            alt={form.file.name}
                                            style={{ maxWidth: 80, maxHeight: 80, borderRadius: 8, objectFit: 'cover', marginBottom: 8 }}
                                        />
                                        <Typography variant="body2">{form.file.name}</Typography>
                                    </Box>
                                ) : (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, position: 'relative' }}>
                                        {form.file && (
                                            <IconButton
                                                size="small"
                                                sx={{ position: 'absolute', top: 0, right: 0, zIndex: 2, background: '#fff' }}
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    setForm(f => ({ ...f, file: null }));
                                                }}
                                            >
                                                <CloseIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                        <CloudUploadIcon sx={{ fontSize: 40, color: "#1976d2" }} />
                                        <Typography variant="body2">
                                            {form.file ? form.file.name : "Arrastra y suelta un archivo aquí o haz clic para seleccionar o pegar una imagen"}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid>
                            <Button
                                variant="contained"
                                color="primary" disabled={!form.name || !form.type || !form.file}
                                onClick={handleUpload}
                            >
                                Subir archivo
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            ) : (
                <Box sx={{ padding: 3 }}>
                    <DataGrid
                        rows={filteredRows}
                        columns={columns}
                        pageSizeOptions={[10, 20, 50, 100]}
                        getRowHeight={() => 'auto'}
                        sx={{
                            ...tableStyles
                        }}
                        disableRowSelectionOnClick
                    />
                </Box>
            )}
        </Box>
    );
};